$(document).ready(function () {

  var coverage, undertone, shade, variant;
  var free_gift = '';



  var shade_match = JSON.parse(document.querySelector('#shade-match').textContent);

  $(".single-selection").click(function (e) {
    $(this)
      .closest(".optionBox")
      .find(".single-selection")
      .removeClass("active");
    $(this).addClass("active");

    var name = $(this).find("input").data("result");


    if (name != undefined) {
      if (
        name == "question_3" || 
        name == "question_4" || 
        name == "question_5" ||
        name == "question_8a"||
        name == "question_8"
      ) {
        if (name == "question_3") {
          coverage = $(this).find("input").data("value");
        }
        if (name == "question_4") {
          shade = $(this).find("input").data("value");

          if ($(this).hasClass("active")) {
            $(this).find(".option_select_radio").attr("checked", "checked");
          }
        }
        if (name == "question_5") {
          undertone = $(this).find("input").data("value");
        }
        if ($("#concealer-application-sponge-8a").is(':checked')) {
          free_gift = 'sponge';
        } else if($("#concealer-application-brush-8a").is(':checked')) {
          free_gift = 'brush';
        }
        if (name == "question_8a") {
          free_gift = $(this).find("input").data("value");
        }

        document.querySelector(".step-7")?.classList.contains("step-7-uk") &&
        document.querySelectorAll(".step-8a").forEach(el => {
          el.remove(), free_gift = "brush";
        });

      }

      updateResults();
    }
  });

  function updateResults() {

    if (coverage !== undefined && shade !== undefined && undertone !== undefined) {
      let quiz_result_url_location = '/pages/quiz-result/';
      let split_test_result_url_location = document.body.getAttribute('data-quiz-result-location');

      if (split_test_result_url_location) {
        if (split_test_result_url_location.length > 0) {
          quiz_result_url_location = split_test_result_url_location;
        }
      }

      variant = shade_match[shade][undertone][coverage];
      $("#quiz_result_variant").val(variant.title);
      $("#quiz_result_variant_id").val(variant.id);
      $("#quiz_result_coverage").val(coverage);
      $("#quiz_result_free_gift").val(free_gift);
 
      
      $("#quiz_result_url").val(`https://${window.location.hostname}${quiz_result_url_location}${variant.title}+${variant.id}+${coverage}+gift-${free_gift}`);
      
      
    }
  }

  $(".multi-selection").click(function (e) {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).addClass("active");
    }
  });



  $(".comn-btn").click(function (e) {
    $("html, body").animate({ scrollTop: 0 }, "slow");

    if ($(this).hasClass('btn_final')) {
      console.log('btn_final');
      return;
    }
 
    if (
      $(this)
        .closest(".step-5 .optionBox")
        .find(".single-selection")
        .hasClass("active")
    ) {
      $(this).closest(".question-Box").hide();
      $(".step-6").show();
      stepDataLayer(this);
    } else if ($(this).hasClass("shade-help")) {
      var selectedUndertone = this.getAttribute('data-undertone-value');

      if (selectedUndertone) {
        $(`[data-result="question_5"][data-value="${selectedUndertone}"]`)
        .attr("checked", "checked");
        undertone = selectedUndertone;
        updateResults();
      }

      $(this).closest(".question-Box").hide();
      $(this).closest(".question-Box").next(".question-Box").fadeIn();
      stepDataLayer(this);
    } else if ($(this).hasClass("novalidate")) {
      $(this).closest(".question-Box").hide();
      $(this).closest(".question-Box").next(".question-Box").fadeIn();
      stepDataLayer(this);
    } else if (this.getAttribute('data-quiz-step') === '0') {
      console.log('Step 0');
      $(this).closest(".question-Box").hide();
      $(this).closest(".question-Box").next(".question-Box").fadeIn();
      stepDataLayer(this);
    } else {
      if (
        $(this)
          .closest(".optionBox")
          .find(".single-selection, .multi-selection")
          .hasClass("active")
      ) {
        $(this).closest(".question-Box").hide();
        $(this).closest(".question-Box").next(".question-Box").fadeIn();
        stepDataLayer(this);
      } else {
        $(this).closest(".mob-bottom").find(".error-msg").fadeIn();
      }
    }

    $(this)
      .closest(".question-Box")
      .next(".question-Box")
      .find(".optionbox-row")
      .removeClass("active");
    progress();


  });

  $(".pop-nextBtn").click(function (e) {
    $(this).closest(".question-Box").hide();
    $(".step-6").fadeIn();
    stepDataLayer(this);
    progress();
  });

  $(".nextSelection").click(function (e) {
    $(this).closest(".question-Box").hide();
    $(this).closest(".question-Box").next(".question-Box").fadeIn();
    stepDataLayer(this);
    progress();
  });

  $(".btn-back").click(function () {
    if ($(this).closest(".question-Box").hasClass("step-6")) {
      if (
        $(this)
          .parents()
          .find(".step-3")
          .find(".coverage-row")
          .hasClass("active")
      ) {
        $(".question-Box.step-5").show();
        $(".question-Box.step-6").hide();
      } else {
        $(this).closest(".question-Box").hide();
        $(this).closest(".question-Box").prev(".question-Box").fadeIn();
        $(".error-msg").hide();
        progress();
        $(".pop-body").fadeOut();
      }
    } else {
      $(this).closest(".question-Box").hide();
      $(this).closest(".question-Box").prev(".question-Box").fadeIn();
      $(".error-msg").hide();
      progress();
      $(".pop-body").fadeOut();
      $(".colorlight, .colordark").show();
    }
    if ($(this).closest('.question-Box').prev('.question-Box').hasClass('step-1')) $('.banner-quiz').show();


  if ($(".step-7 .optionBox").find(".single-selection").hasClass("active")) {
    if (!($('#concealer-application-other').is(':checked') || $('#concealer-application-fingers').is(':checked')) && 
    (!$('#concealer-application-brush-8a').is(':checked') || $('#concealer-application-sponge-8a').is(':checked'))) {
      $(".question-Box.step-8").hide();
      $(".question-Box.step-8a").hide();
      $(".question-Box.step-7").fadeIn();
    }
  }


  });

  $('[data-result="question_5"]').change(function(e) {
    $("#" + this.getAttribute('data-value') + "-popup").fadeIn();
  });

  $(".get-popup1").click(function (e) {
    $("#cool-popup").fadeIn();
  });

  $(".get-popup2").click(function (e) {
    $("#warm-popup").fadeIn();
  });

  $(".get-popup3").click(function (e) {
    $("#neutral-popup").fadeIn();
  });

  $(".closePop").click(function (e) {
    $(".pop-body").fadeOut();
  });

  var quizForm = document.querySelector('#quiz-form');
  if (quizForm) {
    quizForm.addEventListener('submit', formSubmit);
  }

  initLogosSlider();
});

function formSubmit(evt) {
  evt.preventDefault();
  console.log('formSubmit');

  const properties = {};
  const formData = new FormData(this);
  for (const pair of formData.entries()) {
    properties[pair[0]] = pair[1];
  }
  console.log('properties', properties);

  // Store the email in localStorage
  if (properties.email && properties.email !== '' && isEmail(properties.email)) {
    localStorage.setItem("quizUserEmail", properties.email); // Store valid email in localStorage
  } else {
    localStorage.setItem("quizUserEmail", ''); // Set empty string if no email is present or invalid
  }


  if (properties.email && properties.email !== '' && isEmail(properties.email)) {
    document.body.classList.add('loading');
    $('.quiz-email__error').hide();
    try { if (window.posthog) posthog.capture('lead', { lead_type: 'cc_quiz', email: properties.email }); } catch(e) {}

    abstractEmail(properties.email)
      .then(response => response.json())
      .then(response => {
        if (response.deliverability === "DELIVERABLE") {
          klaviyoIdentify(properties);
        } else {
          identifyCallback(properties.email);
        }
      });
  } else {
    if ($('.quiz-email__input').val() == '') {
      $('.quiz-email__error').show();
      $('.quiz-email__error').html('Enter your email above');
    } else if ($('.quiz-email__input').val() != '' && !isEmail($('.quiz-email__input').val())) {
      $('.quiz-email__error').show();
      $('.quiz-email__error').html('Please enter valid email address');
    }
    return false;
  }
}

function abstractEmail(email) {
  const options = {method: 'GET'};
  const ABSTRACT_API_KEY = '271838bd67234b17906a3c1f580b10a6';
  const requestURL = `https://emailvalidation.abstractapi.com/v1?api_key=${ABSTRACT_API_KEY}&email=${email}`;
  const abstractRequest = fetch(requestURL, options)
    .catch(err => console.error(err));
  
  return abstractRequest;
}

async function klaviyoIdentify(properties) {
  let companyID = 'WVhPzg';
  let listID = 'Yz5chL';

  if (window.location.hostname === 'fieracosmetics.co.uk') {
    companyID = 'WVhPzg';
    listID = 'Yz5chL';
  } else if (window.location.hostname === 'fieracosmetics.com') {
    companyID = 'HEyw3X';
    listID = 'TyjeKb';

    // TryNow customers get added to a different list
    if (window.trynow && typeof window.trynow.hasPassedTryLink === 'function') {
      try {
        var hasPassed = await window.trynow.hasPassedTryLink();
        if (hasPassed) {
          listID = 'R4NSwH';
        }
      } catch (e) {}
    }
  }

  const options = {
    method: 'POST',
    headers: {revision: '2025-01-15', 'content-type': 'application/json'},
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Quiz',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: properties.email,
                properties: properties
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list', id: listID
            }
          }
        }
      }
    })
  };

  try {
    await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyID}`, options);
  } catch (error) {
    console.error(error);
  } finally {
    identifyCallback(properties.email);
  }
}

function identifyCallback(email) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "quiz_lead",
    email: email
  });

  if (window.TriplePixel) {
    TriplePixel("Contact", {email: email});
  }

  var shade_name = document.querySelector("#quiz_result_variant").value.replace(/ /g, '-');
  var shade_id = document.querySelector("#quiz_result_variant_id").value;
  var coverage = document.querySelector("#quiz_result_coverage").value;
  var free_gift = document.querySelector("#quiz_result_free_gift").value;


  let quiz_result_url_location = '/pages/quiz-result/';
  let split_test_result_url_location = document.body.getAttribute('data-quiz-result-location');

  if (split_test_result_url_location) {
    if (split_test_result_url_location.length > 0) {
      quiz_result_url_location = split_test_result_url_location;
    }
  }

  function resultsRedirect(quiz_result_url_location, shade_name, shade_id, coverage, free_gift) {
    document.body.classList.remove('loading');
    $('.success_msg').show();
    setTimeout(() => {
      window.location.href = `${quiz_result_url_location}${shade_name.toLowerCase()}+${shade_id}+${coverage}+gift-${free_gift}`;
    }, 1000);
  }
  resultsRedirect(quiz_result_url_location, shade_name, shade_id, coverage, free_gift);

}

function stepDataLayer(button) {
  const stepNumber = button.getAttribute('data-quiz-step');
  const stepQuestion = button.getAttribute('data-quiz-question');

  // console.log('stepNumber', stepNumber);
  // console.log('stepQuestion', stepQuestion);

  if (stepNumber && stepQuestion) {
    window.dataLayer = window.dataLayer || [];
    const dataLayerObject = {
      event: "quiz_progress",
      step: stepNumber,
      question: stepQuestion
    };
    if (parseInt(stepNumber, 10) >= 1) $(".banner-quiz").hide();
    else $(".banner-quiz").show();
    dataLayer.push(dataLayerObject);
  }
}

function progress() {
  var progressVal = $(".question-Box:visible").attr("data-wdth");
  $(".prgress-1").css("width", progressVal + "%");
  if (progressVal == 98) {
    progressbar();
  }
}

var id = 0;
function progressbar() {
  var elem = document.getElementById("analyzeProgress");
  var width = 1;
  id = setInterval(frame, 60);
  function frame() {
    if (width >= 100) {
      clearInterval(id);
      window.setTimeout(function () {
        $(".step-11").hide();
        $(".step-12").fadeIn();
      }, 100);
    } else {
      width++;
      elem.style.width = width + "%";
    }

    $(".progVal").html(width + "%");
  }
}


function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function initLogosSlider() {
  console.log('initLogosSlider()');
  const swiper = new Swiper('#quiz-logos-swiper', {
    loop: true,
    speed: 3000,
    autoplay: {
      delay: 0
    },
    freeMode: {
      enabled: true,
      sticky: false,
    },
    centeredSlides: false,
    slidesPerView: 3,
    spaceBetween: 10,
    breakpoints: {
      400: {
        slidesPerView: 4
      },
      600: {
        slidesPerView: 6,
        spaceBetween: 10
      },
      700: {
        slidesPerView: 6,
        spaceBetween: 10
      },
      750: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      850: {
        slidesPerView: 5,
        spaceBetween: 10
      },
      950: {
        slidesPerView: 6,
        spaceBetween: 10
      },
      1050: {
        slidesPerView: 7,
        spaceBetween: 10
      }
    }
  });
  
}
